import React from 'react';
import {Box} from '@mui/material';
import PropsTypes from 'prop-types';

const DefaultLayoutWrapper = ({children, ...rest}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        backgroundColor: (theme) => theme.palette.background.default,

        '&.appMainFixedFooter': {
          pb: {xs: 12, xl: 14.5},
        },
        '&.appMainFixedHeader': {
          pt: {xs: 8, sm: 10},
          '& .app-bar': {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9,
            width: '100%',
            maxWidth: '100%',
          },
        },
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default DefaultLayoutWrapper;

DefaultLayoutWrapper.propTypes = {
  children: PropsTypes.node,
};
